import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Recaptcha from 'react-google-recaptcha';
import moment from 'moment';
import { months, getFullYearsArray } from './utility';

import {
  requestGenerateStatement,
} from '../../actions';

const dateFormat = 'L LT';

class ExportHistoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recaptchaRef: React.createRef(),
      exportType: '1',
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
    };
    this.handleStatementChange = this.handleStatementChange.bind(this);
    this.generateStatement = this.generateStatement.bind(this);
    this.onSubmitWithReCAPTCHA = this.onSubmitWithReCAPTCHA.bind(this);
  }

  async onSubmitWithReCAPTCHA(event) {
    event.preventDefault();
    const token = await this.state.recaptchaRef.current.executeAsync();
  }

  handleStatementChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: parseInt(value)
    });
  }

  generateStatement() {
    const { dispatch } = this.props
    const { month, year, recaptchaRef } = this.state;
    const recaptchaValue = recaptchaRef.current.getValue();
    const requestParams = {
      month,
      year,
      type: 'MONTHLY_STATMENTS',
      captcha: recaptchaValue,
    }
    dispatch(requestGenerateStatement(requestParams))
      .then((res) => {
        if (res.type === 'GENERATE_STATEMENT_SUCCESS') {
          this.props.toggleModal(null);
        }
      });
  }

  render() {
    const { historyType, exportData } = this.props;
    const { exportType, month, year, recaptchaRef } = this.state;

    const years = getFullYearsArray();

    let useHistory = 'transactions';

    if (historyType) {
      switch (historyType) {
        case 'transfers':
          useHistory = 'fees';
          break;
        default:
          useHistory = historyType;
          break;
      }
    }

    if (exportType === '2') {
      return (
        <form className="login-content" onSubmit={this.onSubmitWithReCAPTCHA}>
          <Recaptcha
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
            onChange={this.generateStatement}
            size="invisible"
            onExpired={() => {}}
            onErrored={(e) => {
              this.showError(e);
            }}
          />

          <div className="grid-x modal-main">
            <div className="modal-title">
              Export History
            </div>
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">PDF Statement</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <div className="input-wrapper">
                <select id="month" className="modal-input" name="month" value={month} onChange={this.handleStatementChange}>
                  {months.map((item, idx) => (
                    <option key={`month-${idx + 1}`} value={item.key}>{item.label}</option>
                  ))}
                </select>
              </div>
              <div className="input-wrapper">
                <select id="year" className="modal-input" name="year" value={year} onChange={this.handleStatementChange}>
                  {years.map((item, idx) => (
                    <option key={`year-${idx + 1}`} value={item}>{item}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <div className="button-area" style={{maxWidth: '400px', margin: 'auto'}}>
                <button className="button" type="button" onClick={() => this.setState({exportType: '1'})}>
                  <span>
                    Back
                  </span>
                </button>
                <button className="vlt-button" type="submit">
                  <span>
                    Generate PDF Statement
                  </span>
                </button>
              </div>
            </div>
          </div>
        </form>
      );
    }

    return (
      <div className="grid-x modal-main">
        <div className="modal-title">
          Export History
        </div>
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-heading">What would you like to export?</div>
        </div>
        <div className="cell small-12 medium-12 large-12">
          <p>
            Your CSV will contain a log of your <b>{useHistory}</b>.
          </p>
          <p>
            The PDF is a statement of <b>transactions</b> for your selected month.
          </p>
        </div>
        <div className="cell small-12 medium-12 large-12 modal-actions">
          <div className="button-area" style={{maxWidth: '400px', margin: 'auto'}}>
            <button className="vlt-button" type="button" onClick={() => exportData()}>
              <span>
                CSV History
              </span>
            </button>
            <button className="vlt-button" type="button" onClick={() => this.setState({exportType: '2'})}>
              <span>
                PDF Statement
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.history.errors,
  success: state.history.success,
  vhistory: state.history.history,
  histPagination: state.history.pagination,
  subHistory: state.history.subHistory,
  subPagination: state.history.subPagination,
  ledger: state.ledger.ledger,
  ledgerPagination: state.ledger.pagination,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(ExportHistoryModal));
